import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDeviceStateInfo,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
  saveDurationValueAfterActionColorType,
  saveInitialActionInfo,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectColorActionHue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/SelectColorActionScreens/SelectColorActionHue/SelectColorActionHue'
import SelectColorActionHueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/SelectColorActionScreens/SelectColorActionHue/SelectColorActionHue'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectColorActionHueIOS) : withStyles(SelectColorActionHue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    currentAction: {
      colorType,
      actionDeviceNumber,
    },
    isChangeActionStateMode,
    isChangeActionMode,
    isEditActionMode,
    initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isEditActionMode,
    actionDeviceNumber,
    colorType,
    isChangeActionStateMode,
    isChangeActionMode,
    isMobile,
    path,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveActionStateDescription,
  saveActionDeviceStateInfo,
  saveInitialActionInfo,
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveDurationValueAfterActionColorType,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectColorActionHueEnhanced = enhance

export default withRouter(SelectColorActionHueEnhanced)
